<template>
  <div>
    <object><embed src="/user_terms.pdf" class="pdf" /></object>
  </div>
</template>
<script>
export default {
  name: 'Terms',
  data() {
    return {
      link: '',
    }
  },
}
</script>

<style lang="sass" scoped>
embed
  width: 100vw
  height: 100vh
</style>
